module.exports = __webpack_public_path__ + "static/media/17.6b9be90b.svg";